import { render, staticRenderFns } from "./sale_table.vue?vue&type=template&id=74f779aa&scoped=true&"
import script from "./sale_table.vue?vue&type=script&lang=js&"
export * from "./sale_table.vue?vue&type=script&lang=js&"
import style0 from "./sale_table.vue?vue&type=style&index=0&id=74f779aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f779aa",
  null
  
)

export default component.exports